import { Tooltip as ChakraTooltip } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { TooltipDefaultProps, type TooltipProps } from './Tooltip.types';

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, trigger, hasArrow, ...props }, ref) => {
    return (
      <ChakraTooltip.Root {...props}>
        <ChakraTooltip.Trigger asChild>{trigger}</ChakraTooltip.Trigger>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content ref={ref}>
            {hasArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {children}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </ChakraTooltip.Root>
    );
  }
);

Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = TooltipDefaultProps;

export { Tooltip };
